/*
  Исковое заявление: деньги иска, суд и кнопка (§6.4.5, вариант А макетов,
  выбран владельцем 07.10.2026).

  Суд по умолчанию - районный суд участка дома (решение владельца того же дня);
  поле можно сменить на любой суд из справочника или вписать свой. Расходы на
  представителя заявляются, только если сумма внесена.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { documents as documentsCount, money } from '../api/format.js'
import { Field, Notice } from './Common.jsx'
import CourtField from './CourtField.jsx'

function Tiles({ form }) {
  if (form.price === null) {
    return (
      <Notice kind="warn">
        <div className="notice__what">Цену иска пока не посчитать.</div>
        <div className="notice__do">{form.preview_problem}</div>
      </Notice>
    )
  }
  return (
    <div className="grid grid--even">
      <div className="tile tile--plain">
        <div className="money__label">Цена иска</div>
        <div className="money__value">{money(form.price)}</div>
        <div className="money__note">долг и пени за месяцы приказа</div>
      </div>
      <div className="tile tile--plain">
        <div className="money__label">Пошлина по иску</div>
        <div className="money__value">{money(form.lawsuit_fee)}</div>
        <div className="money__note">взыскивается с ответчика целиком</div>
      </div>
      <div className="tile tile--good">
        <div className="money__label">Зачёт за приказ</div>
        <div className="money__value">{money(form.offset)}</div>
        <div className="money__note">по внесённой платёжке</div>
      </div>
      <div className="tile tile--loss">
        <div className="money__label">Доплатить</div>
        <div className="money__value money__value--burn">{money(form.to_pay)}</div>
        <div className="money__note">перед подачей иска</div>
      </div>
    </div>
  )
}

/* «5 000» и «5000,00» - одно число; пусто - расходы не заявляются. */
function amount(text) {
  const cleaned = text.replace(/\s/g, '').replace(',', '.')
  return cleaned === '' ? null : cleaned
}

export default function LawsuitBuild({ accountId, form, sections, sectionsError, onDone }) {
  const [court, setCourt] = useState(form.default_court ?? '')
  const [costs, setCosts] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const [done, setDone] = useState(null)

  async function build(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    setDone(null)
    try {
      const documents = await api.buildLawsuit(accountId, {
        court_name: court.trim() || null,
        representative_costs: amount(costs),
      })
      const message = `Исковое заявление сформировано: ${documentsCount(documents.length)} на вкладке «Суд» - иск, расчёт и выписка.`
      /* Подтверждение и здесь, у кнопки: общее уведомление стоит наверху
         карточки, за экраном от блока иска (осмотр 07.10.2026 - та же
         ловушка, что описана в `OrderCancellation.jsx`). */
      setDone(message)
      onDone(message, 'ok')
    } catch (failure) {
      setError(failure)
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="section card">
      <h2 className="section__title">Исковое заявление</h2>
      <Tiles form={form} />
      <form onSubmit={build}>
        <div className="row row--fields">
          <CourtField
            label="Суд"
            value={court}
            onChange={setCourt}
            sections={sections}
            error={sectionsError}
            placeholder="выберите из списка или впишите свой"
          />
          <Field label="Расходы на представителя, ₽" width="s">
            <input
              className="field__input"
              value={costs}
              onChange={(event) => setCosts(event.target.value)}
              placeholder="не заявлять"
            />
          </Field>
          <button className="button" type="submit" disabled={busy}>
            Сформировать исковое заявление
          </button>
        </div>
      </form>
      <div className="muted">
        {form.default_court
          ? 'По умолчанию - районный суд участка дома. Если иск подсуден мировому судье, Арбитр ЖКХ предупредит об этом в документе - тогда выберите участок.'
          : form.court_problem}
      </div>
      {done ? <Notice kind="ok">{done}</Notice> : null}
      {error ? <Notice error={error} /> : null}
    </section>
  )
}
